import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {BannerBoldText, BannerFlexWrapper} from '../Banner';
import {BannerButtonWrapper} from '../Banner/Banner.styles';
import WarningMessage from '../elements/WarningMessage';
import {useWorkspaceBanners} from './useWorkspaceBanners';
import {BannerWithMargin} from './WorkspaceBanners.styles';

export const WorkspaceBanners = () => {
  const {
    dismissWorkspaceBanner,
    shouldShowCliVersionWarning,
    shouldShowPanelAutoGenInfo,
  } = useWorkspaceBanners();
  return (
    <>
      {shouldShowCliVersionWarning && (
        <WarningMessage
          content={
            <p>
              Your version of wandb is outdated. Please upgrade with: pip
              install wandb --upgrade
            </p>
          }
          className="slow-warning"
          onDismiss={() => dismissWorkspaceBanner('cli-version-warning')}
        />
      )}
      {shouldShowPanelAutoGenInfo && (
        <BannerWithMargin variant="info">
          <BannerFlexWrapper>
            <Icon name="lightbulb-info" />
            <div>
              <BannerBoldText>
                Automatic panel generation is enabled for this workspace.
              </BannerBoldText>
              <p>
                Weights & Biases automatically generates panels in this
                workspace whenever new keys are logged. You can switch to manual
                mode by resetting your workspace.
              </p>
            </div>
          </BannerFlexWrapper>
          <BannerFlexWrapper>
            <BannerButtonWrapper
              variant="info"
              aria-label="dismiss"
              onClick={() => dismissWorkspaceBanner('panel-auto-gen-info')}>
              <Icon name="close" />
            </BannerButtonWrapper>
          </BannerFlexWrapper>
        </BannerWithMargin>
      )}
    </>
  );
};
